const getters = {
  getCategories(state) {
    return state.categories
  },
  getTopCategories(state) {
    return state.topCategories
  },
  getIsAppLoading(state) {
    return state.isAppLoading
  },
  getQuicKViewProduct(state) {
    return state.quickViewProduct
  }
}

export default getters
